// material-ui
import { Box, Stack, Typography } from '@mui/material';

// project imports
import Settings from 'views/terminology';
import { themeColors } from 'views/ConstantColors';

// assets
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';

const WORKSPACE_NAVY = '#213363';

const Configurations = () => (
    <Box
        sx={{
            minHeight: '100%',
            color: themeColors.text.primary
        }}
    >
        <Box
            component="header"
            sx={{
                mb: { xs: 2, sm: 2.5 },
                p: { xs: 2, sm: 2.5 },
                backgroundColor: '#ffffff',
                border: `1px solid ${themeColors.grey[200]}`,
                borderRadius: '10px'
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 1.75, sm: 2 }}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                justifyContent="space-between"
            >
                <Stack direction="row" spacing={1.75} alignItems="center">
                    <Box
                        sx={{
                            width: { xs: 44, sm: 48 },
                            height: { xs: 44, sm: 48 },
                            flexShrink: 0,
                            display: 'grid',
                            placeItems: 'center',
                            borderRadius: '9px',
                            backgroundColor: WORKSPACE_NAVY,
                            color: '#ffffff',
                            boxShadow: 'inset 0 -3px 0 rgba(15, 23, 42, 0.18)'
                        }}
                    >
                        <SettingsSuggestOutlinedIcon sx={{ fontSize: { xs: 24, sm: 27 } }} />
                    </Box>
                    <Box>
                        <Typography
                            component="h1"
                            sx={{
                                color: themeColors.text.primary,
                                fontSize: { xs: '1.25rem', sm: '1.5rem' },
                                fontWeight: 700,
                                lineHeight: 1.25
                            }}
                        >
                            Organization Configuration
                        </Typography>
                        <Typography
                            sx={{
                                mt: 0.5,
                                maxWidth: 720,
                                color: themeColors.text.secondary,
                                fontSize: { xs: '0.8rem', sm: '0.875rem' },
                                lineHeight: 1.55
                            }}
                        >
                            Maintain the reference records that power travel requests, approvals, and finance workflows.
                        </Typography>
                    </Box>
                </Stack>

                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{
                        flexShrink: 0,
                        px: 1.5,
                        py: 0.9,
                        ml: { xs: 7.25, sm: 0 },
                        border: `1px solid ${themeColors.grey[200]}`,
                        borderRadius: '8px',
                        backgroundColor: themeColors.grey[50]
                    }}
                >
                    <Box
                        aria-hidden="true"
                        sx={{
                            width: 7,
                            height: 7,
                            borderRadius: '2px',
                            backgroundColor: themeColors.warning.main
                        }}
                    />
                    <Typography sx={{ color: WORKSPACE_NAVY, fontSize: '0.75rem', fontWeight: 700 }}>9 configuration areas</Typography>
                </Stack>
            </Stack>
        </Box>

        <Settings />
    </Box>
);

export default Configurations;
